module.exports = __webpack_public_path__ + "img/aziende_invoiceweb.f89e4816.png";